import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useContext } from 'react';

import page404 from '../../assets/img/404.png';
import LoginContext from '../../context/UserContext';

const PageNotFound = () => {
    const { first_name } = useContext(LoginContext)

    const history = useHistory();

    const BackToHome = () => {
        history.push('');
    };

    return (
        <div>
            <main className='main'>
                <section className='home'>
                    <div className='home__container container'>
                        <div className='home__data'>
                            <span className='home__subtitle'>Error 404</span>
                            <h1 className='home__title'>Hey {first_name}</h1>
                            <p className='home__description'>
                                Parece que no podemos encontrar la página. <br /> Continúa navegando...
                            </p>
                            <a onClick={(e) => BackToHome()} className='home__button ml-5'>
                                Regresar a Entrénate
                            </a>
                        </div>
                        <div className='home__img'>
                            <img src={page404} alt='' />
                            <div className='home__shadow' />
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default PageNotFound;
